
import Vuex from 'vuex'

export const store =  new Vuex.Store({
	state: {
		mainView: 'quote-main',
		mvProp1: '',
		mvProp2: '',
		mvProp3: [],

		userQuoteList: [],
		userQuoteComp: '0',

		userBuildList: [],
		userBuildComp: '0',

		orgList: [],
		orgComp: '0',

		contactList: [],
		contactComp: '0',


	},

	mutations: {
		setMainView(state, payload) { state.mainView = payload.name; state.mvProp1 = payload.prop1; state.mvProp2 = payload.prop2; state.mvProp3 = payload.prop3 },

		setQuotes(state, payload) { state.userQuoteList = payload.info; state.userQuoteComp = payload.info1; },
		setQuotesComp(state, payload) { state.userQuoteComp = payload.info1; },

		setBuilds(state, payload) { state.userBuildList = payload.info; state.userBuildComp = payload.info1; },
		setBuildsComp(state, payload) { state.userBuildComp = payload.info1; },

		setOrgs(state, payload) { state.orgList = payload.info; state.orgComp = payload.info1; },
		setOrgComp(state, payload) { state.orgComp = payload.info1; },

		setContacts(state, payload) { state.contactList = payload.info; state.contactComp = payload.info1; },
		setContactComp(state, payload) { state.contactComp = payload.info1; },

		

  	},

	actions: {
		getMainView(context, payload) { context.commit("setMainView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2, prop3: payload.prop3 })  },
		getAllUserQuotes(context, payload) {
			context.commit("setQuotesComp", { info1: '0' }) 
			axios.get('/utility/user/quote/getuserquotes')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setQuotes", { info: b, info1: '1' }) 
	          	});
		},
		getAllUserBuilds(context, payload) {
			context.commit("setBuildsComp", { info1: '0' }) 
			axios.get('/utility/user/contact/getallbuildsbyuser')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setBuilds", { info: b, info1: '1' }) 
	          	});
		},
		getAllUserOrgs(context, payload) {
			context.commit("setOrgComp", { info1: '0' }) 
			axios.get('/utility/user/org/getallorgsbyuser')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setOrgs", { info: b, info1: '1' }) 
	          	});
	    },
	    getAllUserContacts(context, payload) {
			context.commit("setContactComp", { info1: '0' }) 
			axios.get('/utility/user/contact/getallcontactsbyuser')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setContacts", { info: b, info1: '1' }) 
	          	});
	    }
	}

})